import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import LoadingIndicator from '../uiold/LoadingIndicator';

type Props = {
  src: string;
  isModal?: boolean;
};

type State = {
  isLoading: boolean;
  showError: string | null | undefined;
};

const ERROR_LOADING_IMAGE = t(
  'Error: Unable to display image. Use Download button in upper right.',
);

class PreviewImage extends Component<Props, State> {
  state: State = {
    isLoading: true,
    showError: null,
  };

  componentDidMount() {
    // TODO: Use helpers/loadImage
    let image = new Image();
    image.onload = () => {
      this.setState({
        isLoading: false,
      });
    };
    image.onerror = () => {
      this.setState({ showError: ERROR_LOADING_IMAGE });
    };
    image.src = this.props.src;
  }

  render() {
    if (this.state.showError) {
      return (
        <div className="error" onClick={(e) => e.stopPropagation()}>
          <p>{this.state.showError}</p>
        </div>
      );
    }
    if (this.state.isLoading) {
      return <LoadingIndicator />;
    }
    return (
      <View style={styles.imageWrapper}>
        <img
          alt="preview"
          src={this.props.src}
          style={{
            height: '80%',
            width: '80%',
            overflow: 'scroll',
            alignSelf: 'center',
            objectFit: 'contain',
          }}
        />
      </View>
    );
  }
}

let styles = StyleSheet.create({
  imageWrapper: {
    flex: 1,
    backgroundColor: '#000000CC',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});

export default PreviewImage;
